<template>
  <div>
    <custom-input-text
        hide-details
        @input="onChangeFilter"
        label="ФИО или паспортные данные"
        style="max-width: 230px"
        clearable
        v-model="options.search"
    />
    <crud-template
        @opened:form-dialog="onOpenedFormDialog"
        @deleteItem="deleteItem"
        @dialogClosed="clearForm"
        ref="formTemplate" :editedItem.sync="formData">
      <template #default="{editItemHandler}">
        <div class="text-right mb-3">
          <btn-with-tooltip @click="editItemHandler('create')" class-name="action-btn" color="primary">
            <v-icon small>fas fa-plus</v-icon>
            <template #tooltip>Создать</template>
          </btn-with-tooltip>
        </div>
        <v-data-table
            disable-pagination
            :headers="headers"
            disable-sort
            hide-default-footer
            :items="items">
          <template #item.passport_series="{item: {passport_series, passport_number}}">{{passport_series}} {{passport_number}}</template>
          <template #item.name="{item:{first_name, last_name, mid_name}}">{{
              `${last_name} ${first_name} ${mid_name}`
            }}
          </template>
          <template #item.created_at="{item:{created_at}}">{{ created_at|parseDate }}</template>
          <template #item.action="{item}">
            <div class="action-btn-wrap">
              <v-btn @click="editItemHandler('edit', item)" class="action-btn" color="warning">
                <v-icon x-small>fas fa-pencil-alt</v-icon>
              </v-btn>
              <v-btn @click="editItemHandler('delete', item)" class="action-btn" color="error">
                <v-icon x-small>fas fa-trash</v-icon>
              </v-btn>
            </div>
          </template>
        </v-data-table>
        <v-pagination @input="changePage" :length="lastPage" v-if="lastPage > 1 || options.page> 1"
                      v-model="options.page"/>
      </template>

      <template #form-content="{isUpdate, loading}">
        <validation-observer ref="formObs" v-slot="{handleSubmit}">
          <form @submit.prevent="handleSubmit(() => save(isUpdate))">
            <v-row class="form-dialog-modal">
              <v-col cols="12" v-if="!hasOnlyOneMko">
                <custom-autocomplete
                    label="МКО"
                    v-model="selectedMko"
                    vid="mko_id"
                    :items="mkos"
                />
              </v-col>
              <v-col cols="12">
                <custom-autocomplete
                    customNoData
                    :delay="500"
                    :disabled="!!isUpdate"
                    clearable
                    :items="users"
                    @input="onSelectUser"
                    @search="searchUser"
                    v-model="formData.user_id"
                    :item-text="({first_name, last_name}) => `${first_name} ${last_name}`"
                    item-value="user_id"
                    label="Пользватель">
                  <template #no-data>
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-title>Чтобы найти нужный пользватель введите имя, фамилия, паспортные даные ...
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </template>
                </custom-autocomplete>
              </v-col>
              <v-col cols="12">
                <div class="d-flex mx-n1">
                  <div class="px-1">
                    <custom-input-text
                        :pattern="'AA'"
                        alwaysUppercase
                        label="Серия паспорта"
                        :disabled="!!formData.user_id"
                        v-model="formData.passport_series"
                    ></custom-input-text>
                  </div>
                  <div class="px-1 flex-grow-1">
                    <custom-input-text
                        :pattern="'#######'"
                        only="number"
                        :disabled="!!formData.user_id"
                        label="Номер паспорта"
                        v-model="formData.passport_number"
                    ></custom-input-text>
                  </div>
                </div>
              </v-col>
              <v-col cols="12" sm="6">
                <custom-input-text
                    label="ФИО"
                    rules="required"
                    :disabled="!!formData.user_id"
                    v-model="formData.full_name"
                ></custom-input-text>
              </v-col>
              <v-col cols="12" sm="6">
                <custom-input-text
                    :pattern="'##############'"
                    label="ПИНФЛ"
                    :disabled="!!formData.user_id"
                    v-model="formData.pinfl"
                ></custom-input-text>
              </v-col>
              <v-col cols="12" sm="6">
                <custom-input-text
                    :pattern="'##-###-##-##'"
                    prefix="+998"
                    label="Телефон"
                    v-model="formData.phone"
                ></custom-input-text>
              </v-col>
              <v-col cols="12" sm="6">
                <custom-date-picker
                    label="Дата создание кредита"
                    :max="new Date()"
                    v-model="formData.credit_started_date"
                ></custom-date-picker>
              </v-col>
              <v-col cols="12" sm="6">
                <custom-input-text
                    only="number"
                    label="Сумма кредита"
                    v-model="formData.credit_amount"
                ></custom-input-text>
              </v-col>
              <v-col cols="12" sm="6">
                <custom-input-text
                    only="number"
                    label="Сумма Долга на сегодняшний день"
                    v-model="formData.credit_debt"
                ></custom-input-text>
              </v-col>
              <v-col cols="12">
                <custom-date-picker
                    label="Дата последней оплаты"
                    :max="new Date()"
                    v-model="formData.last_paid_date"
                ></custom-date-picker>
              </v-col>
              <v-col cols="12">
                <h4 class="ma-0">Оцените опасность заемщика</h4>
                <div class="pt-7">
                  <v-slider
                      thumb-label="always"
                      max="10"
                      :thumb-size="24"
                      v-model="formData.rating"
                      min="1"
                  >
                    <template #prepend>
                      <span class="text-no-wrap">Не опасный</span>
                    </template>
                    <template #append><span class="text-no-wrap">Очень опасный</span></template>
                  </v-slider>
                </div>
              </v-col>
              <v-col cols="12">
                <custom-autocomplete
                    rules="required"
                    :items="reasons"
                    v-model="formData.reason"
                    label="Причина"
                />
              </v-col>
              <v-col cols="12">
                <custom-input-text
                    rules="required"
                    v-model="formData.comment"
                    label="Комментарии"
                />
              </v-col>
              <v-col cols="12">
                <v-btn width="100%" color="primary" type="submit" :loading="loading">Сохранить</v-btn>
              </v-col>
            </v-row>

          </form>
        </validation-observer>
      </template>
    </crud-template>
  </div>
</template>

<script>
import crudTemplate from "@/components/ui/crud/template";
import {messages} from '@/utils/constants'
import {debounce} from "@/utils/pureFunctions";

const BLACK_LIST_DEFAULT_FORM_DATA = {
  user_id: null,
  full_name: null,
  pinfl: null,
  passport_series: null,
  phone: null,
  credit_started_date: null,
  last_paid_date: null,
  credit_amount: null,
  credit_debt: null,
  rating: null,
  reason: null,
  passport_number: null,
  comment: null
}

export default {
  data() {
    return {
      lastPage: 0,
      options: {
        page: 1,
        search: null,
      },
      selectedMko: null,
      loadingSearchUser: false,
      formData: {
        ...BLACK_LIST_DEFAULT_FORM_DATA
      },
      headers: [
        {
          text: 'ФИО',
          value: 'full_name'
        },
        {
          text: 'ПИНФЛ',
          value: 'pinfl'
        },
        {
          text: 'Паспортные данные',
          value: 'passport_series'
        },
        {
          text: 'Телефон',
          value: 'phone'
        },
        {
          text: 'Сумма кредита',
          value: 'credit_amount'
        },
        {
          text: 'Сумма Долга на сегодняшний день',
          value: 'credit_debt'
        },
        {
          text: 'Рейтинг',
          value: 'rating'
        },
        {
          text: 'Причина',
          value: 'reason'
        },
        {
          text: 'Коментарии',
          value: 'comment'
        },
        {
          text: 'Дата',
          value: 'created_at'
        },
        {
          text: 'Действие',
          value: 'action'
        }
      ],
      items: [],
      users: [],
      mkos: []
    }
  },
  methods: {
    onChangeFilter: debounce(function () {
      this.options.page = 1
      this.changePage()
    }, 300),
    async changePage() {
      const {page} = this.$route.query
      this.$showLoading()
      if (page !== `${this.options.page}`) {
        await this.$router.replace({query: {page: `${this.options.page}`}})
      }
      await this.getItems()
      this.$clearLoading()
    },
    onSelectUser(id) {
      if (id) {
        const user = this.users.find(item => item.user_id === id)
        if (user) {
          this.formData = {
            ...this.formData,
            passport_number: user.passport_number,
            passport_series: user.passport_series,
            full_name: user.full_name,
            pinfl: user.pnfl,
          }
        }
      } else {
        this.formData = {...BLACK_LIST_DEFAULT_FORM_DATA}
      }

    },
    async onOpenedFormDialog({isUpdate, item}) {

      if (this.hasOnlyOneMko) {
        this.selectedMko = this.mkos[0].id
      }
      if (isUpdate) {
        await this.searchUser(item.first_name)
        this.onSelectUser(item.user_id)
      }
    },
    async deleteItem(item) {
      this.$showLoading()
      try {
        await this.$http.delete(`admin/blacklist/${item.id}`)
        this.items = this.items.filter(listItem => {
          return listItem.id !== item.id
        })
        this.$setSuccess({text: messages.onDelete})
      } catch (e) {
        this.$setResponseError({error: e})
      } finally {
        this.$clearLoading()
      }
    },
    async clearForm() {
      const {formObs} = this.$refs
      if (formObs) formObs.reset()
    },
    async getItems() {
      try {
        const {data: {data, links: {last_page}}} = await this.$http.get('admin/blacklist', {params: {...this.options}})
        this.items = data
        this.lastPage = last_page
      } catch (e) {
        this.$setResponseError({error: e})
      }
    },
    async save(isUpdate) {
      const {formTemplate} = this.$refs
      if (formTemplate) formTemplate.$showFormLoading()
      try {
        let formData = {...this.formData}
        if (formData.phone) {
          formData.phone = '998' + formData.phone.replace(/-/g, '')
        }
        if (isUpdate) {
          await this.update(formData)
        } else {
          await this.create(formData)
        }
        formTemplate.$clearFormLoading()
        if (formTemplate) {
          formTemplate.closeFormDialog()
        }
        this.$setSuccess({text: messages.onSave})

      } catch (e) {
        this.$setResponseError({error: e})
        this.$setFormError({error: e, obs: this.$refs.formObs})
        formTemplate.$clearFormLoading()
      }
    },
    async create(formData) {
      try {
        await this.$http.post("admin/blacklist", formData)
        await this.getItems()
      } catch (e) {
        return Promise.reject(e)
      }

    },
    async update(formData) {
      try {
        await this.$http.put(`admin/blacklist/${formData.id}`, formData)
        await this.getItems()
      } catch (e) {
        return Promise.reject(e)
      }

    },
    async getMkos() {
      try {
        this.mkos = await this.$store.dispatch('getMkos')
      } catch (e) {
        this.$setResponseError({error: e})
      }
    },
    async searchUser(val) {
      if (val && val.trim() !== '') {
        this.loadingSearchUser = true
        try {
          const data = await this.$store.dispatch('searchUser', {search: val, mko_id: this.selectedMko})
          if (data.length) {
            this.users = data.map(item => {
              item.full_name = `${item.last_name} ${item.first_name} ${item.mid_name}`
              return item
            })
          }
        } catch (e) {
          this.$setResponseError({error: e})
          this.$setFormError({error: e, obs: this.$refs.formObs})
        } finally {
          this.loadingSearchUser = false
        }
      }
    }
  },
  components: {crudTemplate},
  computed: {
    reasons() {
      return [
        'Увольнение с работы',
        'Болезнь',
        'Переехал в другой город',
        'Переехал в другую страну',
        'Смерть родных',
        'Другое',
        'Не известно'
      ]
    },
    hasOnlyOneMko() {
      return this.mkos.length === 1
    }
  },
  async created() {
    const {page} = this.$route.query
    if (page && !isNaN(page)) this.options.page = parseInt(page)
    this.$showLoading()
    await this.getItems()
    await this.getMkos()
    this.$clearLoading()
  }
}
</script>
